import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type {
  TypePostSmartSearchFeedbackParams,
  TypePostSmartSearchFeedbackResponse,
} from '~/types/smart-search.types';

/**
 * [스마트검색] 피드백 전송 API
 */
const fetchPostSmartSearchFeedback = async ({ queryId, helpful }: TypePostSmartSearchFeedbackParams): Promise<null> => {
  const { data } = await axiosInstance.post<TypePostSmartSearchFeedbackResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.POST_SMART_SEARCH_FEEDBACK}/${queryId}/feedback`,
    { helpful }
  );
  return data.data;
};

/**
 * [스마트검색] 피드백 전송 Mutation Hook
 */
export const usePostSmartSearchFeedback = () => {
  return useMutation({
    mutationFn: fetchPostSmartSearchFeedback,
    meta: { background: true },
  });
};

registerMockAPI({
  method: 'post',
  endpoint: '/api-delivery-agency/smart-search/:queryId/feedback',
  label: '스마트검색/피드백',
  scenarios: [
    {
      name: '정상 응답',
      response: { data: null },
    },
    {
      name: '유효하지 않은 요청 (60400)',
      response: { error: { code: 60400, message: '요청이 유효하지 않습니다.' } },
      status: 400,
    },
    {
      name: '서버 오류 (60500)',
      response: { error: { code: 60500, message: '서버에서 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
